import type { ButtonHTMLAttributes } from 'react';

interface PrimaryButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  tone?: 'primary' | 'dark' | 'ghost';
}

export function PrimaryButton({
  className = '',
  tone = 'primary',
  ...props
}: PrimaryButtonProps) {
  const toneClass =
    tone === 'primary'
      ? 'bg-[var(--primary)] text-[var(--primary-foreground)] shadow-[0_12px_28px_rgba(107,78,230,0.24)]'
      : tone === 'dark'
        ? 'bg-[var(--foreground)] text-white shadow-[0_12px_24px_rgba(26,26,26,0.18)]'
        : 'border border-[rgba(26,26,26,0.08)] bg-white/72 text-[rgba(26,26,26,0.72)] shadow-[0_10px_20px_rgba(62,48,23,0.06)]';

  return (
    <button
      type={props.type ?? 'button'}
      className={[
        'inline-flex min-h-[var(--button-height)] items-center justify-center rounded-full px-5 text-[11px] font-extrabold uppercase tracking-[0.04em] transition-all active:scale-[0.98] disabled:pointer-events-none disabled:opacity-50 min-[430px]:min-h-[var(--button-height-comfortable)] min-[430px]:text-[12px]',
        toneClass,
        className,
      ].join(' ')}
      {...props}
    />
  );
}
